import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Button, Dimmer, Loader, Modal } from "semantic-ui-react"
import { updateCart, deleteCart, setActiveVehicleIdFromDeepLink } from "../../../v1/actions/user"
import { createCustomersPromotion } from "../../../v1/actions/promotion"
import { setDeepLinkMeta } from "../../../v1/reducers/cart"
import Appointment from "./Appointment"

const DEEP_LINK_PROMO_CODE = "DeclineServicePromotion10"

const AppointmentDeepLink = ({
  location,
  history,
  cart,
  updateCart,
  deleteCart,
  setActiveVehicleIdFromDeepLink,
  createCustomersPromotion,
  setDeepLinkMeta
}) => {
  const params = new URLSearchParams(location.search)
  const vehicleIdParam = params.get("vehicle_id")
  const servicesParam = params.get("services")
  const shopIdParam = params.get("shop_id")
  const sourceOrderIdParam = params.get("source_order_id")

  const hasDeepLinkParams = !!(vehicleIdParam && servicesParam && shopIdParam)
  const [isLoading, setIsLoading] = useState(hasDeepLinkParams)
  const [showCartConflictModal, setShowCartConflictModal] = useState(false)
  const hasRun = useRef(false)

  const setupCart = async () => {
    try {
      const vehicleId = Number(vehicleIdParam)
      await setActiveVehicleIdFromDeepLink(vehicleId)

      const parsedServices = JSON.parse(servicesParam)
      const serviceEvents = parsedServices.map((s) => {
        const event = { service_definition_id: s.service_definition_id, event: "added" }
        if (s.position !== null && s.position !== undefined) event.position = s.position
        return event
      })

      await updateCart(serviceEvents, vehicleId)

      let cartId = null
      await updateCart(
        [{ event: "set_shop", shop_id: Number(shopIdParam) }],
        vehicleId,
        undefined,
        undefined,
        {
          successCallback: (result) => {
            cartId = result?.id
          },
          ...(sourceOrderIdParam && { sourceOrderId: Number(sourceOrderIdParam) })
        }
      )

      if (cartId) {
        createCustomersPromotion({ code: DEEP_LINK_PROMO_CODE, cartId })
        if (sourceOrderIdParam) {
          setDeepLinkMeta({ sourceOrderId: Number(sourceOrderIdParam), cartId })
        }
      }

      history.replace(location.pathname)
    } catch (err) {
      console.error("AppointmentDeepLink: failed to initialize", err)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!hasDeepLinkParams || hasRun.current) return
    hasRun.current = true

    if (cart?.order_services?.length > 0) {
      setShowCartConflictModal(true)
      setIsLoading(false)
    } else {
      setupCart()
    }
  }, [])

  const handleConfirmCartDelete = async () => {
    setShowCartConflictModal(false)
    setIsLoading(true)
    if (cart?.id) await deleteCart(cart.id)
    await setupCart()
  }

  const handleCancelCartDelete = () => {
    setShowCartConflictModal(false)
    history.replace(location.pathname)
  }

  if (isLoading) {
    return (
      <Dimmer active inverted>
        <Loader>Setting up your appointment...</Loader>
      </Dimmer>
    )
  }

  return (
    <>
      <Modal
        size="small"
        open={showCartConflictModal}
        onClose={handleCancelCartDelete}
        className="cart-exist-modal"
      >
        <Modal.Header>Cart Already Exists</Modal.Header>
        <Modal.Content>
          <p>
            Your cart already has services. Do you want to delete it and continue with the new
            services?
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button className="secondary-button" onClick={handleCancelCartDelete}>
            No
          </Button>
          <Button
            style={{ width: "auto" }}
            className="primary-button"
            onClick={handleConfirmCartDelete}
          >
            Yes, Delete & Continue
          </Button>
        </Modal.Actions>
      </Modal>
      <Appointment />
    </>
  )
}

function mapStateToProps(state, ownProps) {
  const user = state.user || {}
  const params = new URLSearchParams(ownProps.location?.search || "")
  const vehicleIdParam = params.get("vehicle_id")
  const vehicleId = vehicleIdParam ? Number(vehicleIdParam) : user.activeVehicleId
  const cart = (user.active_carts || []).find((c) => c.vehicle_id == vehicleId)
  return { cart: cart || {} }
}

export default withRouter(
  connect(mapStateToProps, {
    updateCart,
    deleteCart,
    setActiveVehicleIdFromDeepLink,
    createCustomersPromotion,
    setDeepLinkMeta
  })(AppointmentDeepLink)
)
